import { Link } from 'react-router-dom';
import { blogs } from '../../data/blog';
import Header from '../common/Header';
import Footer from '../common/Footer';

function Blogs() {
  // Sort blogs by date in descending order (latest blog first)
  const sortedBlogs = blogs
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className='main-wrapper'>
      <Header />
      <div style={{ marginTop: '120px', padding: '20px 100px' }}>
        <h1 className='mb-4 fw-bold fs-2 '>Our Blogs</h1>

        <div className='row'>
          {sortedBlogs.map((blog) => (
            <div key={blog.slug} className='col-md-4 mb-4'>
              <div className='card h-100 shadow-sm border-0'>
                <img
                  src={blog.image}
                  alt={blog.title}
                  className='card-img-top rounded'
                />
                <div className='card-body'>
                  <h2 className='card-title h5 fw-semibold'>{blog.title}</h2>
                  <p className='card-text text-muted'>{blog.description}</p>
                  <Link
                    to={`/blog/${blog.slug}`}
                    className=' fw-medium '
                    style={{ color: '#d8b36b' }}
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Blogs;
